module.exports = __webpack_public_path__ + "static/media/Mozambique.8b64a676.png";